import { StyleSheet } from 'react-native'

const styles = (TABLET_PORTRAIT_UP_DIM) => StyleSheet.create({
  container: {
    flex: 1,
    paddingVertical: 10,
    width: '100%',
    maxWidth: 800
  }
})

export default styles
